import { createJSONStorage } from 'zustand/middleware';
import { getWeaveSessionId } from '@frontend/auth-helpers';
import { createShallowStore, createStoreWithPersist } from '@frontend/store';
import { SessionDismissState, TimedDismissState } from '../types';

interface BackfillStore {
  batch1ReadyBannerDismiss: TimedDismissState;
  batch2CompleteBannerDismiss: TimedDismissState;
  recordingsBannerDismiss: SessionDismissState;

  dismissBatch1ReadyBanner: (state: TimedDismissState) => void;
  dismissBatch2CompleteBanner: (state: TimedDismissState) => void;
  dismissRecordingsBanner: () => void;
  checkRecordingsBannerDismiss: () => boolean;
  reset: () => void;
}

const initialState = {
  batch1ReadyBannerDismiss: {} as TimedDismissState,
  batch2CompleteBannerDismiss: {} as TimedDismissState,
  recordingsBannerDismiss: { dismissed: false, sessionId: null } as SessionDismissState,
};

export const useBackfillStore = createStoreWithPersist<BackfillStore>(
  (set, get) => ({
    ...initialState,

    dismissBatch1ReadyBanner: (state) =>
      set((prev) => ({ batch1ReadyBannerDismiss: { ...prev.batch1ReadyBannerDismiss, ...state } })),
    dismissBatch2CompleteBanner: (state) =>
      set((prev) => ({ batch2CompleteBannerDismiss: { ...prev.batch2CompleteBannerDismiss, ...state } })),
    dismissRecordingsBanner: () =>
      set({ recordingsBannerDismiss: { dismissed: true, sessionId: getWeaveSessionId() || null } }),
    checkRecordingsBannerDismiss: (): boolean => {
      const { recordingsBannerDismiss } = get();
      return recordingsBannerDismiss.dismissed && recordingsBannerDismiss.sessionId === getWeaveSessionId();
    },

    reset: () => set(initialState),
  }),
  {
    name: 'call-intel-trial-backfill',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) =>
      ({
        batch1ReadyBannerDismiss: state.batch1ReadyBannerDismiss,
        batch2CompleteBannerDismiss: state.batch2CompleteBannerDismiss,
        recordingsBannerDismiss: state.recordingsBannerDismiss,
      } as BackfillStore),
  },
  {
    name: 'BackfillStore',
    enabled: true,
  }
);

export const useBackfillShallowStore = createShallowStore<BackfillStore>(useBackfillStore);
